import * as actionTypes from './actionTypes';
import * as actions from './index';

export const massEditSelected = (clipIds) => {
    return {
        type: actionTypes.MASS_EDIT_SELECTED,
        payload: { clips: clipIds }
    };
};

export const resetMassEditClips = () => {
    return {
        type: actionTypes.RESET_MASS_EDIT_SELECTED
    }
}

export const selectClip = (clip) => {
    return {
        type: actionTypes.SELECT_CLIP,
        payload: { clip: clip }
    };
};

export const resetTickedClips = () => {
    return {
        type: actionTypes.RESET_TICKED_CLIPS
    }
}

export const resetMultiSelected = () => {
    return {
        type: actionTypes.RESET_MULTISELECTED
    }
}

export const clipDragStart = (clipId) => {
    return {
        type: actionTypes.CLIP_DRAG_START,
        payload: { clipId: clipId }
    }
}

export const cutClipStart = (clipId) => {
    return {
        type: actionTypes.CUT_CLIP_START,
        payload: { cutting: true }
    }
}

export const cutClipSuccess = (clipId) => {
    return {
        type: actionTypes.CUT_CLIP_SUCCESS,
        payload: { cuttedCLip: clipId, cutting: false }
    }
}

export const cutClipFail = (clipId) => {
    return {
        type: actionTypes.CUT_CLIP_FAIL,
        payload: { clipId: clipId, cutting: false }
    }
}

export const cutClip = (clipId, newtitle, batch, preset, source, add = {}) => {
    return dispatch => {
        dispatch(cutClipStart())
        window.flow.cutQuick(clipId, newtitle, batch, preset, source, add).then(response => {
            if (response.success) {
                // interval to check process state
                let interval = setInterval(function () {
                    window.flow.getProcess(response.processid).then(p => {
                        console.log(p.getStatus());
                        if (p.getStatus() == 'done') {
                            clearInterval(interval);
                            dispatch(cutClipSuccess(clipId));
                            dispatch(actions.getClipById(clipId));
                        } else if (p.getStatus() == 'error') {
                            clearInterval(interval);
                            dispatch(cutClipFail(response));
                        }
                    })
                }, 2000);
            } else {
                dispatch(cutClipFail(response));
            }
        }).catch(response => {
            console.log(response);
            dispatch(cutClipFail(response));
        });
    }
}


export const grabMainThumb = (clipId, frame, width, height) => {

    const params = {
        createthumbmf: 1,
        post_width: width,
        post_height: height,
        autothumbmode: 'replacemainthumb',
        dumprate: 1,
        dumptype: 'numberofframes',
        transcoder: 'ffmpeg',
        findtags: 'sourcefile',
        lframe: frame,
        fframe: frame,
    };

    console.log("GRAB MAIN THUMB");

    return dispatch => {
        dispatch({ type: actionTypes.CLIP_GRAB_MAINTHUMB_START });
        window.flow.newProcess('vob2jpg', 'Flow2 replacemainthumb', { clipid: clipId, parameters: params }).then(res => {
            console.log(res);
            dispatch(actions.getClipById(clipId));
            dispatch(actions.updateMetadata("clip", clipId, {}));
            let interval = setInterval(function () {
                window.flow.getProcess(res.processid).then(p => {
                    console.log(p);
                    console.log(p.getStatus());
                    if (p.getStatus() == 'done') {
                        clearInterval(interval);
                        dispatch({ type: actionTypes.CLIP_GRAB_MAINTHUMB_SUCCESS });
                        dispatch(actions.updateMetadata("clip", clipId, {}));
                    } else if (p.getStatus() == 'error') {
                        clearInterval(interval);
                        dispatch({ type: actionTypes.CLIP_GRAB_MAINTHUMB_FAIL });
                    }
                })
            }, 2000);
        }).catch(res => {
            console.log(res);
            dispatch({ type: actionTypes.CLIP_GRAB_MAINTHUMB_FAIL });
        });
    }
}

export const convertImage = (clipid, presetting) => {
    return dispatch => {
        let sendObj = { clipid, presetting };
        console.log(sendObj);
        window.flow.processCreate('imageconverter', 'imageconverter', sendObj).then(response => {
            if (response.success) {
                // interval to check process state
                let interval = setInterval(function () {
                    window.flow.getProcess(response.processid).then(p => {
                        console.log(p.getStatus());
                        if (p.getStatus() == 'done') {
                            clearInterval(interval);
                            dispatch(actions.getClipById(clipid));
                        } else if (p.getStatus() == 'error') {
                            clearInterval(interval);
                            console.error("FAIL: CONVERT IMAGE " + clipid  + " " + presetting);
                        }
                    })
                }, 2000);
            } else {
                console.error("FAIL: CONVERT IMAGE " + clipid  + " " + presetting);
            }
        }).catch(response => {
            console.log(response);
            console.error("FAIL: CONVERT IMAGE " + clipid  + " " + presetting);
        });
    }
}

export const newClipRelation = (clipId, ids, bidirectional = false) => {
    return (dispatch, getState) => {
        ids.forEach(id => {
            // set relation from clip to other
            window.flow.newClipRelation({clipa_id:clipId, clipb_id:id, relation_ab:'', relation_ba:''}).then(res => {
                console.log(res);
            }).catch(res => {
                console.log(res);
            });
            if(bidirectional) {
                // set relation from other to clip
                window.flow.newClipRelation({clipa_id:id, clipb_id:clipId, relation_ab:'', relation_ba:''}).then(res => {
                    console.log(res);
                }).catch(res => {
                    console.log(res);
                });
            }
        });
    }
}

export const deleteClipRelation = (clipId, ids) => {
    return (dispatch, getState) => {
        let count = 0;
        ids.forEach(id => {
            // set relation from clip to other
            window.flow.delClipRelation(id).then(res => {
                console.log(res);
                count++;
                if(count === ids.length) {
                    //console.log("---------------load related");
                    // load related
                    dispatch(actions.getRelatedClips([clipId]));
                }
            }).catch(res => {
                console.log(res);
            });
        });
    }
}

export const setRelatedClip = (relatedClip, currentClips) => {
    return {
        type: actionTypes.SET_RELATED_CLIP,
        payload: { relatedClip: relatedClip, currentClips: currentClips }
    }
}

export const resetRelatedClip = () => {
    return {
        type: actionTypes.SET_RELATED_CLIP,
        payload: { relatedClip: null, currentClips: [] }
    }
}

export const loadClipReferences = (clip, ids) => {
    return (dispatch, getState) => {
        dispatch({ type: actionTypes.CLIP_REFERENCES_LOAD_START });

        //const ids = [9837,9835,9832,9308,9204];
        
        //window.flow.getProjectsByFields([{ field: "id", type: 'IDLIST', value: [9837,9835,9832,9308,9204].join(), 'order': 'name' }]);
        let count = 0;
        ids.forEach(id => {
            window.flow.getProjectById(id).then(res => {
                //console.log(res);
                count++;
                dispatch({ type: actionTypes.CLIP_REFERENCES_LOAD_SUCCESS, res: res, id: clip, done: ids.length === count });
            }).catch(res => {
                dispatch({ type: actionTypes.CLIP_REFERENCES_LOAD_FAIL });
            });
        });
        
    };
};
